/*
 * @Author: Cozy
 * @Date: 2024-05-09 17:09:27
 * @LastEditors: Cozy
 * @LastEditTime: 2024-06-28 14:54:19
 * @FilePath: /SChatUI/src/ChatList.js
 * @Description: 
 * 
 * Copyright (c) 2024 by Cozy, All Rights Reserved. 
 */
// ChatList.js
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { Flex, FlexItem, List, ListItem, Button, Modal} from '@chatui/core';
import "@chatui/core/dist/index.css";

import { useContext } from 'react';
import { AuthContext } from './AuthContext';



export default function Home() {
    const { clearAuth, accessibleServices} = useContext(AuthContext);
    let params = useParams();
    let service = params.service || 'AHI AI chat';
    const title = service;
    const navigate = useNavigate();
    const [sessionList, setSessionList] = useState([]);
    const [showServiceModal, setShowServiceModal] = useState(false);

    useEffect(() => {
        // Load stored sessions from localStorage
        const storedSessions = JSON.parse(localStorage.getItem(service + '_sessionList')) || [];
        setSessionList(storedSessions);
    }, [service]); // Add 'service' as a dependency

    // Handle creating a new chat session
    const handleNewChat = useCallback(() => {
        const newSessionId = uuidv4(); // Generate a new session ID
        const updatedSessionList = [...sessionList, newSessionId]; // Append to the list

        // Update localStorage and state
        localStorage.setItem(service + '_sessionList', JSON.stringify(updatedSessionList));
        setSessionList(updatedSessionList);

        handleChatNavigation(newSessionId)
    }, [sessionList, service, navigate]);

    // Handle clearing all sessions
    const handleClearAll = useCallback(() => {
        if (window.confirm("Are you sure you want to clear all sessions?")) {
            localStorage.removeItem(service + '_sessionList'); // Remove the session list
            setSessionList([]); // Clear the state
        }
    }, [service]);

    // Navigate to an existing chat session
    const handleChatNavigation = (sessionId) => {
        navigate(`/${service}/c/${sessionId}`);
    };
    const toggleServiceModal = () => {
        setShowServiceModal(!showServiceModal);
    };
    const handleServiceClick = (service) => {
        setShowServiceModal(false);
        navigate(`/${service}`);
    };
    return (
        <div style={{ background: 'var(--gray-7)' }}>
            <Flex center>
                <FlexItem style={{ margin: '0 1em' }}>
                    <h3>欢迎来到 {title}</h3>
                    <Button className="mbtn" color="primary" onClick={handleNewChat}>  新对话  </Button>
                    {/* <br /> */}
                    <Button className="mbtn" onClick={handleClearAll}>清空历史对话</Button>
                    {accessibleServices.length > 1 && (
                        <Button className="mbtn" onClick={toggleServiceModal}>切换服务</Button>
                    )}

                    <Button className="mbtn" onClick={clearAuth}>退出登录</Button>
                    <p style={{ margin: '0.5em 0 ' }}>点击下方聊天列表继续会话:</p>
                    { /*
                        <button onClick={refreshAccessToken}>
                            refresh Token
                        </button> 
                    */} 
                </FlexItem>
            </Flex>
            <List bordered={true}>
                {sessionList.length > 0 ? (
                    sessionList.map((sessionId, index) => (
                        <ListItem key={index} as="button" content={sessionId} onClick={() => handleChatNavigation(sessionId)} />
                    ))
                ) : (
                    <ListItem content="No sessions available." />
                )}
            </List>
            <Modal 
                active={showServiceModal}
                title="Available Services" 
                showClose={false}
                onClose={toggleServiceModal}
                actions={[
                    {
                        label: 'Close',
                        color: 'primary',
                        onClick: toggleServiceModal,
                    },
                ]}
            > 
                <List>
                    {accessibleServices.map((service) => (
                    <ListItem  key={service} onClick={() => handleServiceClick(service)} style={{paddingLeft:'25px'}} content ={service} />
                ))}                 
                </List>

            </Modal>
        </div>
    );
}
